<template>
  <InteractionStepSentWaitingVisaCenter v-if="isVisitVisaCenter"/>
  <InteractionStepSentWaitingNovaPoshta v-else/>
</template>

<script>
  import InteractionStepSentWaitingVisaCenter from './InteractionStepSentWaitingVisaCenter'
  import InteractionStepSentWaitingNovaPoshta from './InteractionStepSentWaitingNovaPoshta'
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  export default {
    name: 'InteractionStepSentWaiting',
    mixins: [interactionStepMixin],
    components: {
      InteractionStepSentWaitingVisaCenter,
      InteractionStepSentWaitingNovaPoshta,
    },
    computed: {
      isVisitVisaCenter() {
        return !!this.$store.state.interaction.data.visa_center
      }
    }
  }
</script>

<style lang="less">

</style>